import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";
import AOS from "aos";
import "aos/dist/aos.css";
import { ChevronDown } from "lucide-react";

function FAQs() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const faqs = [
    {
      question: "What makes your service different?",
      answer:
        "We combine convenience, speed, and a curated selection of gifts to make gifting effortless. Our same-day delivery sets us apart, ensuring your last-minute needs are met with ease. Plus, our special gift packages offer exceptional value and personalized options.",
    },
    {
      question: "How does the same-day delivery work?",
      answer:
        "Simply place your order before our cutoff time 3:00 PM CST, and we'll deliver your gift the very same day. Check our website for more details on the same-day delivery and cutoff times.",
    },
    {
      question: "Can I schedule a delivery for a future date?",
      answer:
        "Yes! You can book your delivery for the next day, or days ahead ensuring your gift arrives precisely when you want it to.",
    },
    {
      question: "What types of gifts do you offer?",
      answer:
        "We offer a wide variety of gifts to suit any occasion, from birthdays and anniversaries to thank-you gifts and more. Our selection includes curated gift boxes, personalized items, and unique finds.",
    },
    {
      question: "What are your special gift packages?",
      answer:
        "Our Blossom Delight, Charming Bloom, and VIP Opulence packages combine stunning floral arrangements with carefully chosen accessories, offering a convenient and affordable way to create a personalized gift.",
    },
    {
      question: "What areas do you serve?",
      answer:
        "We currently offer delivery in DFW and environment. Check our website for a complete list of locations.",
    }, 
    {
      question: "How long does delivery take?",
      answer:
        "We offer same-day delivery within 50 miles of Dallas if you place your order before 3 PM local time.",
    },
    {
      question: "Can I customize my hamper?",
      answer:
        "Absolutely! You can select from our curated options to build your own hamper using our builder.",
    },
    {
      question: "What payment methods do you accept?",
      answer:
        "We accept PayPal and Stripe. All payments are secured and encrypted.",
    },
    {
      question: "Can I include a personal message?",
      answer:
        "Yes! You can add a custom message during checkout, and we’ll include a beautifully printed card.",
    },
    {
      question: "What if I need help with my order?",
      answer:
        "Our support team is available via email, phone, and WhatsApp from 9 AM to 8 PM daily.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {/* Breadcrumbs */}
      <div className="max-w-6xl mx-auto px-4">
        <Breadcrumbs />
      </div>

      {/* Hero Section */}
      <section className="text-center py-20 bg-blue-50" data-aos="fade-down">
        <div className="max-w-xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-blue-700 mb-4">Frequently Asked Questions</h1>
          <p className="text-gray-600 text-lg">
            Got a question? We’re here to help. Below are answers to some of the most common questions about Exudee.
          </p>
        </div>
      </section>

      {/* FAQ Accordion */}
      <section className="max-w-3xl mx-auto py-16 px-4 space-y-6" data-aos="fade-up">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-md p-4 bg-white shadow transition-all"
          >
            <button
              className="flex justify-between items-center w-full text-left font-semibold text-blue-700"
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
              <ChevronDown
                className={`w-5 h-5 ml-2 transition-transform ${
                  openIndex === index ? "rotate-180" : "rotate-0"
                }`}
              />
            </button>
            {openIndex === index && (
              <div className="mt-3 text-gray-600 leading-relaxed">{faq.answer}</div>
            )}
          </div>
        ))}
      </section>

      {/* CTA Section */}
      <section className="text-center py-12 bg-blue-100 px-4" data-aos="fade-up">
        <h3 className="text-2xl font-bold text-blue-700 mb-2">Still have questions?</h3>
        <p className="text-gray-700 mb-4">Contact our friendly team — we're happy to help!</p>
        <a href="/contact">
          <button className="bg-blue-600 text-white px-6 py-3 rounded hover:bg-blue-700 transition">
            Reach Out Now
          </button>
        </a>
      </section>

      {/* Footer */}
      <div data-aos="fade-up">
        <Footer />
      </div>
    </>
  );
}

export default FAQs;
